import http from  './axios'

export const login = param =>{return http.post("passport/login",param).then(res=>res.data.data)};



// WEBPACK FOOTER //
// ./src/api/login.js